import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from "react";
import { isAutocompleteSearchSubmit, isAutocompleteSelectSubmit, useCioAutocomplete } from "@constructor-io/constructorio-ui-autocomplete";
import { emitSearchboxImpression, SOURCE_TYPE_CONSTRUCTOR_SEARCH } from "@catchoftheday/analytics";
import { Label } from "@catchoftheday/cg-components";
import { getEnvConfig } from "@catchoftheday/env-config";
import { localStorage } from "@catchoftheday/utilities";
import { useSearchRedirectsLazyQuery } from "../../../../generated/graphql";
import { PRODUCT_SUGGESTION_INDEX_NAME, SEARCH_REDIRECTS_EXPIRY, SEARCH_REDIRECTS_KEY, SEARCH_SUGGESTION_INDEX_NAME } from "../../../consts";
import { constructorConfig } from "../../../consts/config";
import { DropdownOverlay } from "../../../layouts/SearchBar/DropdownOverlay";
import { SearchBarWrapper, SearchBoxZone, Spacer, SuggestedSearchTermsZone } from "../../../layouts/SearchBar/SearchBarLayouts";
import { SearchDropdownZone } from "../../../layouts/SearchBar/SearchDropdownZone";
import { CloseButton } from "../../../pure/SearchBar/CloseButton/CloseButton";
import { SearchButton } from "../../../pure/SearchBar/SearchButton/SearchButton";
import { SearchForm } from "../../../pure/SearchBar/SearchForm/SearchForm";
import { SearchInput } from "../../../pure/SearchBar/SearchInput/SearchInput";
import { SearchTicker } from "../../../pure/SearchBar/SearchTicker/SearchTicker";
import { getTrendingSearchTerms } from "../../../utilities/searchBar/getSearchTermsFromSection";
import { navigateToSearchPage } from "../../../utilities/searchBar/navigateToSearchPage";
import { searchRedirectUrl } from "../../../utilities/searchBar/searchRedirectUrl";
import { SearchProductsContainer } from "../SearchProductsContainer/SearchProductsContainer";
import { SearchTermsContainer } from "../SearchTermsContainer/SearchTermsContainer";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SearchBarContainer = function SearchBarContainer() {
  var _getEnvConfig = getEnvConfig(),
      CONSTRUCTOR_API_KEY = _getEnvConfig.CONSTRUCTOR_API_KEY;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState({
    autocompleteItems: undefined,
    productItems: undefined
  }),
      searchBarItems = _useState2[0],
      setSearchBarItems = _useState2[1];

  var _useState3 = useState([]),
      searchTickerTerms = _useState3[0],
      setSearchTickerTerms = _useState3[1];

  var _useState4 = useState([]),
      searchRedirects = _useState4[0],
      setSearchRedirects = _useState4[1];

  var _useSearchRedirectsLa = useSearchRedirectsLazyQuery(),
      _useSearchRedirectsLa2 = _slicedToArray(_useSearchRedirectsLa, 1),
      getRedirects = _useSearchRedirectsLa2[0];

  var _useCioAutocomplete = useCioAutocomplete(_objectSpread(_objectSpread({}, constructorConfig), {}, {
    apiKey: CONSTRUCTOR_API_KEY,
    onFocus: function onFocus() {
      setIsOpen(true);
      emitSearchboxImpression();
    },
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var item, originalQuery, redirectUrl, _query, _redirectUrl;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsOpen(false);

                if (!isAutocompleteSelectSubmit(event)) {
                  _context.next = 9;
                  break;
                }

                item = event.item, originalQuery = event.originalQuery;
                _context.next = 5;
                return getRedirectUrl(item.value);

              case 5:
                redirectUrl = _context.sent;
                navigateToSearchPage(_objectSpread(_objectSpread({
                  term: item.value,
                  inputTerm: originalQuery,
                  sourceType: SOURCE_TYPE_CONSTRUCTOR_SEARCH
                }, item.groupId && item.groupName ? {
                  category: {
                    id: item.groupId,
                    name: item.groupName
                  }
                } : {}), {}, {
                  redirectUrl: redirectUrl
                }));
                _context.next = 15;
                break;

              case 9:
                if (!isAutocompleteSearchSubmit(event)) {
                  _context.next = 15;
                  break;
                }

                _query = event.query;
                _context.next = 13;
                return getRedirectUrl(_query);

              case 13:
                _redirectUrl = _context.sent;
                navigateToSearchPage({
                  term: _query,
                  inputTerm: _query,
                  sourceType: SOURCE_TYPE_CONSTRUCTOR_SEARCH,
                  redirectUrl: _redirectUrl
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  })),
      query = _useCioAutocomplete.query,
      sections = _useCioAutocomplete.sections,
      getFormProps = _useCioAutocomplete.getFormProps,
      getInputProps = _useCioAutocomplete.getInputProps,
      getMenuProps = _useCioAutocomplete.getMenuProps,
      getItemProps = _useCioAutocomplete.getItemProps,
      getSectionProps = _useCioAutocomplete.getSectionProps,
      getLabelProps = _useCioAutocomplete.getLabelProps;

  var inputProps = getInputProps();

  var toggleDropdownVisibility = function toggleDropdownVisibility() {
    setIsOpen(!isOpen);
  };

  function getRedirectUrl(_x2) {
    return _getRedirectUrl.apply(this, arguments);
  }

  function _getRedirectUrl() {
    _getRedirectUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(term) {
      var _data$searchRedirects, _yield$getRedirects, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(searchRedirects.length === 0)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 3;
              return getRedirects();

            case 3:
              _yield$getRedirects = _context2.sent;
              data = _yield$getRedirects.data;

              if (!(data !== null && data !== void 0 && (_data$searchRedirects = data.searchRedirects) !== null && _data$searchRedirects !== void 0 && _data$searchRedirects.redirects)) {
                _context2.next = 9;
                break;
              }

              setSearchRedirects(data.searchRedirects.redirects);
              localStorage.setItemWithExpiry(SEARCH_REDIRECTS_KEY, JSON.stringify(data.searchRedirects.redirects), SEARCH_REDIRECTS_EXPIRY);
              return _context2.abrupt("return", searchRedirectUrl(term, data.searchRedirects.redirects));

            case 9:
              return _context2.abrupt("return", null);

            case 10:
              return _context2.abrupt("return", searchRedirectUrl(term, searchRedirects));

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _getRedirectUrl.apply(this, arguments);
  }

  useEffect(function () {
    var searchRedirects = localStorage.getItemWithExpiry(SEARCH_REDIRECTS_KEY);

    if (searchRedirects) {
      setSearchRedirects(JSON.parse(searchRedirects));
    }
  }, []);
  useEffect(function () {
    var filterSectionsByName = function filterSectionsByName(name) {
      return sections.filter(function (section) {
        return "indexSectionName" in section && section.indexSectionName === name;
      });
    };

    setSearchBarItems({
      autocompleteItems: filterSectionsByName(SEARCH_SUGGESTION_INDEX_NAME),
      productItems: filterSectionsByName(PRODUCT_SUGGESTION_INDEX_NAME)
    });
  }, [sections]);
  useEffect(function () {
    var _getTrendingSearchTer;

    setSearchTickerTerms(((_getTrendingSearchTer = getTrendingSearchTerms(searchBarItems.autocompleteItems)) === null || _getTrendingSearchTer === void 0 ? void 0 : _getTrendingSearchTer.data.map(function (item) {
      return item.value;
    })) || []);
  }, [searchBarItems.autocompleteItems]);
  return ___EmotionJSX(SearchBarWrapper, null, isOpen && ___EmotionJSX(DropdownOverlay, {
    onClick: toggleDropdownVisibility
  }), ___EmotionJSX(SearchBoxZone, {
    isOpen: isOpen
  }, ___EmotionJSX(SearchForm, getFormProps(), ___EmotionJSX(Label, _extends({
    htmlFor: inputProps.id
  }, getLabelProps()), ___EmotionJSX(SearchInput, _extends({
    isOpen: isOpen
  }, inputProps))), ___EmotionJSX(SearchButton, {
    isOpen: isOpen
  })), ___EmotionJSX(SearchTicker, {
    trendingSearchTerms: searchTickerTerms,
    visible: !isOpen
  }), ___EmotionJSX(SearchDropdownZone, {
    isOpen: isOpen
  }, ___EmotionJSX(CloseButton, {
    onClick: toggleDropdownVisibility
  }), ___EmotionJSX(SuggestedSearchTermsZone, getMenuProps(), ___EmotionJSX(SearchTermsContainer, {
    autocompleteItems: searchBarItems.autocompleteItems,
    getItemProps: getItemProps,
    getSectionProps: getSectionProps
  })), ___EmotionJSX(SearchProductsContainer, {
    searchTerm: query,
    recommendedProducts: searchBarItems.productItems
  }))), ___EmotionJSX(Spacer, null));
};